export default __webpack_public_path__ + "static/shareauto-b5758b81cb3c6c3782d09eb42783713b.png";